// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"cf42e4cd","186":"0cb0ce70","225":"767531c3","344":"1f7b8c4f","372":"92eef259","377":"050ce8a0","738":"4f7d04eb","841":"0db96211","856":"6ec0de24","886":"50a60e1a"}[chunkId] + ".chunk.js";
};